const CURRENCY_SYMBOLS = { USD: "$", EUR: "€", GBP: "£", THB: "฿", SGD: "S$" };

export const money = (amount, currency = "USD") => {
  const sym = CURRENCY_SYMBOLS[currency] || `${currency} `;
  const n = Number(amount || 0);
  return `${sym}${n.toFixed(2)}`;
};

export const PAYMENT_COLORS = {
  paid: "green",
  pending: "orange",
  failed: "red",
};

export const STATUS_COLORS = {
  new: "blue",
  processing: "gold",
  shipped: "cyan",
  completed: "green",
  cancelled: "red",
};

export const STATUS_LABELS = {
  new: "New",
  processing: "Processing",
  shipped: "Shipped",
  completed: "Completed",
  cancelled: "Cancelled",
};
